import { isMobile } from "@common_lib/base/utils/src/tools"

export const useLabelTerms = () => {
  const authStore = useAuthStore()
  const { updateCertification } = authStore
  const { userID } = storeToRefs(authStore)
  const websiteInfoStore = useWebsiteInfoStore()
  const { state: websiteState } = storeToRefs(websiteInfoStore)

  const route = useRoute()
  const router = useRouter()

  const isLoginWithHalf = computed(
    () => websiteState.value.isTempRole && userID.value !== ""
  )

  const { logout } = useLogout({ isMobile: isMobile() })

  const handleRedirection = (resetPassword: boolean, termsVersion: number[]) => {
    if (resetPassword) {
      if (route.name === "ResetPassword") return

      router.replace({
        name: "ResetPassword",
        query: route.query
      })

      return
    }

    if (termsVersion.length) {
      if (route.name === "Terms") return

      router.replace({
        name: "Terms",
        query: {
          ...route.query,
          termsVersion: JSON.stringify(termsVersion)
        }
      })
    }
  }

  onMounted(() => {
    const certification = JSON.parse(localStorage.getItem("certification") ?? "{}")
    const { termsVersion, resetPassword } = certification || {}

    if (!termsVersion && !resetPassword) return

    router.replace({
      path: route.path,
      query: {
        ...route.query,
        termsVersion: termsVersion || undefined,
        resetPassword: resetPassword === "true" ? "true" : undefined
      }
    })

    localStorage.removeItem("certification")
  })

  watch(
    () => [route.query.termsVersion, route.query.resetPassword],
    (
      [currentTermsVersion, currentResetPassword],
      [oldTermsVersion, oldResetPassword]
    ) => {
      if (
        (route.query.termsVersion === undefined ||
          route.query.termsVersion === "[]" ||
          route.query.termsVersion?.length === 0) &&
        (route.query.resetPassword === undefined || route.query.resetPassword === "false")
      ) {
        if (isLoginWithHalf.value) {
          logout()
          router.push({ name: "Home" })
        }

        return
      }

      if (
        oldTermsVersion === currentTermsVersion &&
        oldResetPassword === currentResetPassword
      )
        return

      if (!isLoginWithHalf.value) {
        logout()
        router.push({ name: "Home" })

        return
      }

      const resetPassword = route.query.resetPassword === "true"
      const termsVersion =
        typeof route.query.termsVersion === "string"
          ? JSON.parse(route.query.termsVersion)
          : []

      updateCertification({ resetPassword, termsVersion })
      handleRedirection(resetPassword, termsVersion)
    },
    {
      deep: true
    }
  )
}

export default useLabelTerms
